var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "square-plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4.16667C4.53976 4.16667 4.16667 4.53976 4.16667 5V15C4.16667 15.4602 4.53976 15.8333 5 15.8333H15C15.4602 15.8333 15.8333 15.4602 15.8333 15V5C15.8333 4.53976 15.4602 4.16667 15 4.16667H5ZM2.5 5C2.5 3.61929 3.61929 2.5 5 2.5H15C16.3807 2.5 17.5 3.61929 17.5 5V15C17.5 16.3807 16.3807 17.5 15 17.5H5C3.61929 17.5 2.5 16.3807 2.5 15V5ZM10 6.66667C10.4602 6.66667 10.8333 7.03976 10.8333 7.5V9.16667H12.5C12.9602 9.16667 13.3333 9.53976 13.3333 10C13.3333 10.4602 12.9602 10.8333 12.5 10.8333H10.8333V12.5C10.8333 12.9602 10.4602 13.3333 10 13.3333C9.53976 13.3333 9.16667 12.9602 9.16667 12.5V10.8333H7.5C7.03976 10.8333 6.66667 10.4602 6.66667 10C6.66667 9.53976 7.03976 9.16667 7.5 9.16667H9.16667V7.5C9.16667 7.03976 9.53976 6.66667 10 6.66667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.1a224e20f44f623f2c629446fda860c7.svg";
export { ForwardRef as ReactComponent };